module.exports = __webpack_public_path__ + "static/img/yx04.956fa87b.png";